import React, { useMemo } from 'react'; // custom code: useMemo
import { VideoBlockSchema } from './schema';
import { Segment } from 'semantic-ui-react';
import { defineMessages, useIntl } from 'react-intl';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import { BlockDataForm } from '@plone/volto/components/manage/Form';
import videoSVG from '@plone/volto/icons/videocamera.svg';
import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers/Url/Url'; // custom code

const messages = defineMessages({
  Video: {
    id: 'Video',
    defaultMessage: 'Video',
  },
  NoVideo: {
    id: 'No Video selected',
    defaultMessage: 'No Video selected',
  },
});

const VideoSidebar = (props) => {
  const { data, block, blocksErrors, onChangeBlock, navRoot, contentType } =
    props;
  const intl = useIntl();
  const schema = VideoBlockSchema({ ...props, intl });

  /* custom code start: show the relative url of internal files (#21433) */
  const displayData = useMemo(() => {
    if (!data.url || !isInternalURL(data.url)) {
      return data;
    }
    return {
      ...data,
      url: flattenToAppURL(data.url),
    };
  }, [data]);
  /* custom code end */

  return (
    <>
      {!data.url ? (
        <Segment className="sidebar-metadata-container" secondary>
          {props.intl.formatMessage(messages.NoVideo)}
          <Icon name={videoSVG} size="100px" color="#b8c6c8" />
        </Segment>
      ) : (
        <BlockDataForm
          schema={schema}
          title={intl.formatMessage(messages.Video)}
          onChangeField={(id, value) => {
            onChangeBlock(block, {
              ...data,
              [id]: value,
            });
          }}
          onChangeBlock={onChangeBlock}
          /* custom code start */
          formData={displayData}
          /* custom code end */
          block={block}
          navRoot={navRoot}
          contentType={contentType}
          errors={blocksErrors}
        />
      )}
    </>
  );
};

export default VideoSidebar;
